<template>
  <Modal :open="open" size="medium" @close="$emit('close')">
    <h2 class="text-xl font-bold text-gray-900 mb-6">{{ t("title") }}</h2>

    <div class="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-6">
      <div class="bg-gray-50 border border-gray-200 rounded-xl p-5">
        <div class="flex items-center gap-3 mb-3">
          <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
            <TrendingUpIcon class="w-6 h-6 text-primary" />
          </div>
          <h4 class="text-base font-semibold text-gray-900">{{ t("gross_sales_title") }}</h4>
        </div>
        <p class="text-sm text-gray-500 leading-relaxed">{{ t("gross_sales_desc") }}</p>
        <p class="text-xs text-gray-400 mt-4 italic">{{ t("gross_sales_use") }}</p>
      </div>

      <div class="bg-gray-50 border border-gray-200 rounded-xl p-5">
        <div class="flex items-center gap-3 mb-3">
          <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
            <ShoppingBagIcon class="w-6 h-6 text-primary" />
          </div>
          <h4 class="text-base font-semibold text-gray-900">{{ t("contracts_title") }}</h4>
        </div>
        <p class="text-sm text-gray-500 leading-relaxed">{{ t("contracts_desc") }}</p>
        <p class="text-xs text-gray-400 mt-4 italic">{{ t("contracts_use") }}</p>
      </div>

      <div class="bg-gray-50 border border-gray-200 rounded-xl p-5">
        <div class="flex items-center gap-3 mb-3">
          <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
            <ClipboardListIcon class="w-6 h-6 text-primary" />
          </div>
          <h4 class="text-base font-semibold text-gray-900">{{ t("leads_title") }}</h4>
        </div>
        <p class="text-sm text-gray-500 leading-relaxed">{{ t("leads_desc") }}</p>
        <p class="text-xs text-gray-400 mt-4 italic">{{ t("leads_use") }}</p>
      </div>
    </div>

    <div class="bg-yellow-50 border border-yellow-100 rounded-xl p-4 flex gap-3">
      <LightBulbIcon class="w-5 h-5 text-yellow-500 shrink-0 mt-0.5" />
      <div>
        <p class="text-sm font-semibold text-gray-800">{{ t("why_title") }}</p>
        <p class="text-sm text-gray-600 mt-1 leading-relaxed" v-html="t('why_desc')"></p>
      </div>
    </div>
  </Modal>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Modal } from "@estaly/ui";
import { ShoppingBagIcon, ClipboardListIcon, TrendingUpIcon, LightBulbIcon } from "@heroicons/vue/outline";

export default {
  components: { Modal, ShoppingBagIcon, ClipboardListIcon, TrendingUpIcon, LightBulbIcon },

  props: {
    open: { type: Boolean, required: true },
  },

  emits: ["close"],

  setup() {
    const { t } = useI18n();
    return { t };
  },
};
</script>

<i18n src="./DataSourceInfoModal.i18n.json"></i18n>
